export { useLocalStorage } from './useLocalStorage';
//# sourceMappingURL=index.js.map